import script from "./PageCurtain.vue?vue&type=script&setup=true&lang=js"
export * from "./PageCurtain.vue?vue&type=script&setup=true&lang=js"

import "./PageCurtain.vue?vue&type=style&index=0&id=24d5237c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24d5237c"]])

export default __exports__